/* eslint-disable react/require-default-props */
import React, { useCallback } from 'react';
import { BaseFilter } from '../BaseFilter';
import { Popup } from '../../Popup';
import { Radio } from '../../inputs/Radio';
/** Reversible serializer: encodes both type and value to avoid `1` vs `'1'` collision. */
function serializeValue(v) {
    return `${typeof v}:${String(v)}`;
}
const UNSELECTED_SENTINEL = '__unselected__';
/**
 * SelectFilter
 * Single-select popup filter. Uses `BaseFilter` + `Radio` inside `Popup.Section`.
 * Parity with legacy `CommonSelect.jsx`.
 * @version 1.2.0
 * @since 2026-05-04
 * @updated 2026-05-05 - Replaced button list with Radio component
 * @updated 2026-05-05 - Reversible type-prefixed value encoding (avoids String collision)
 */
export function SelectFilter({ field, label, value, onChange, options, disabled = false, showReset = true }) {
    var _a;
    const selectedOption = (_a = options.find((o) => o.value === value)) !== null && _a !== void 0 ? _a : null;
    const handleReset = useCallback(() => onChange(null), [onChange]);
    return (React.createElement(BaseFilter, { label: label, isActive: value !== null, selectedDisplay: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label, disabled: disabled, onReset: showReset && value !== null ? handleReset : undefined }, (close) => {
        const radioOptions = options.map((opt) => (Object.assign(Object.assign({}, opt), { value: serializeValue(opt.value) })));
        const handleRadioChange = (serialized) => {
            const matched = options.find((o) => serializeValue(o.value) === serialized);
            if (matched) {
                onChange(matched.value);
                close();
            }
        };
        return (React.createElement(Popup.Section, null,
            React.createElement(Radio, { name: `select-filter-${field}`, value: value !== null ? serializeValue(value) : UNSELECTED_SENTINEL, options: radioOptions, onChange: handleRadioChange })));
    }));
}
